// Import the necessary methods from redux-saga/effects for side effects and parallelization
import { all, fork } from "redux-saga/effects";

// Import Saga file for the 'case-summary-one-view' view; you can import other view-specific sagas here
import fetchSummaryOneViewSagaCM from "../../views/case-summary/store/saga";
import dashboardSVOD from "../../views/dashboard/store/saga";
import fetchUsersSaga from "../../views/auth-msal/store/saga";
import dashboardSVODCA from "../../views/community-assets/store/saga";

// The rootSaga is a generator function that uses the `all` effect to run multiple sagas in parallel
function* rootSaga() {
    const sagas = [];
    
    
        sagas.push(fork(fetchSummaryOneViewSagaCM));
        sagas.push(fork(dashboardSVOD));
        sagas.push(fork(fetchUsersSaga));
        sagas.push(fork(dashboardSVODCA));
    
    // `all` takes an array of sagas to be executed in parallel
    // `fork` is a non-blocking call that starts the provided saga
    yield all(sagas)
}

// Export the rootSaga for use in the Redux store configuration
export default rootSaga;